import { useState } from "react";
import { postLEGALS } from "../services/MARKDOWN/postLEGALS";
import { decodeBase64 } from "../utils/decodeBase64";

export const useGetdisclaimer = () => {
    const [terminosModal, setTerminosModal] = useState(false);
    const [politicasModal, setPoliticasModal] = useState(false);
    const [content, setContent] = useState('');
    const [contentTitle, setContentTitle] = useState('');


    function postTerms(term) {
        const requestBody = { "keyList": [{ "key": term }] }
        postLEGALS(requestBody).then((response) => {
            setContentTitle(decodeBase64(JSON.parse(response.data.keyList[0].value).title));
            setContent(decodeBase64(JSON.parse(response.data.keyList[0].value).content));
        });
    }
  return { postTerms, terminosModal, setTerminosModal, politicasModal,setPoliticasModal, content,contentTitle, setContent,setContentTitle }
}
